import { createAction, props } from '@ngrx/store';
import { IItem } from '@app/models/item.model';

export enum ItemActions {
    GetItems = '[Items] Get Items',
    RefreshItems = '[Items] Refresh Items',
    ItemsLoaded = '[Items] Load success',
    PersistItem = '[Items] Persist Item',
    BeginRemoveItems = '[Items] Begin Remove Items',
    RemoveItemsFinished = '[Items] Remove Items Finished',
    UpdateItem = '[Items] Update Item',
    UpdateMassItems = '[Items] Update Mass Items',
    PersistUpdateItem = '[Items] Persist Update Item',
    BeginUpdateItems = '[Items] Begin Update Items',
    UpdateItemsFinished = '[Items] Update Items Finished',
    PersistMassUpdateItems = '[Items] Persist Mass Update Items',
    SelectItem = '[Items] Select Item',
    CheckItem  = '[Items] Check Item',
    UncheckItem  = '[Items] Uncheck Item',
    UncheckAllItems  = '[Items] Uncheck All Items',
    ChangePage = '[Items] Change Page',
    ChangeFilterSort = '[Items] Change Filter Sort',
    ChangeFilter = '[Items] Change Filter',
    ChangeSort = '[Items] Change Sort',
    GetTotalItems = '[Items] Get Total Items',
    TotalItemsLoaded = '[Items] Total Items Loaded',
    BeginCopyAndPasteItems = '[Items] Begin Copy And Paste Items',
    BeginCutAndPasteItems = '[Items] Begin Cut And Paste Items',
    CopyAndPasteItemsFinished = '[Items] Copy And Paste Items Finished',
    CutAndPasteItemsFinished = '[Items] Cut And Paste Items Finished',
    BeginDuplicateItems = '[Items] Begin Duplicate Items',
    DuplicateItemsFinished = '[Items] Duplicate Items Finished',
    BeginChangeOrder = '[Items] Begin Chnage Order',
    ChangeOrderFinished = '[Items] Chnage Order Finished',
    UpdateProjectId = '[Items] Update Project Id',
    ProjectEntered = '[Items] Project Entered',
    BeginCalulateRulesForItems = '[Items] Begin calculate rules for item',
    CalulateRulesForItemsFinished = '[Items] Calculate rules for item finished',
    BeginRecalculateRulesForField = '[Items] Begin recalculate rules for fields',
    RecalculateRulesForFieldFinished = '[Items] Recalculate rules for fields finished',
    BeginAddManyItems = '[Items] Begin Add Many Items',
    AddManyItemsFinished = '[Items] Add Many Items Finished',
    ErrorItems = '[Items] Error'
}

export const PersistItemAction = createAction(
    ItemActions.PersistItem,
    props<{ payload: IItem }>()
);

export const UpdateItemAction = createAction(
    ItemActions.UpdateItem,
    props<{ payload: {item: IItem, isNew?: boolean } }>()
);

export const UpdateMassItemsAction = createAction(
    ItemActions.UpdateMassItems,
    props<{ payload: {itemIds: any[], updateFields: any[] } }>()

);

export const PersistUpdateItemAction = createAction(
    ItemActions.PersistUpdateItem,
    props<{ payload: { item: IItem, changedFields: {fieldTechName, newValue}[] } }>()
);

export const BeginUpdateItemsAction = createAction(
    ItemActions.BeginUpdateItems,
    props<{ payload: { item: IItem, changedFields: string[] }[] }>()
);

export const UpdateItemsFinishedAction = createAction(
    ItemActions.UpdateItemsFinished,
    props<{ payload: { item: IItem, changedFields: string[] }[] }>()
);

export const PersistMassUpdateItemsAction = createAction(
    ItemActions.PersistMassUpdateItems,
    props<{ payload: { itemIds: any[], updateFields: any[] } }>()
);

export const GetItemsAction = createAction(
    ItemActions.GetItems,
    props<{payload: {projectId: any, pageNum: number, filterSortData}}>()
);

export const RefreshItemsAction = createAction(
    ItemActions.RefreshItems,
    props<{ payload: {projectId: any, resetCheckedItems: boolean, allowAddNewItem?: boolean} }>()
);

export const ItemsLoadedAction = createAction(
    ItemActions.ItemsLoaded,
    props<{ payload }>()
);

export const SelectItemAction = createAction(
    ItemActions.SelectItem,
    props<{ payload: IItem }>()
);

export const CheckItemAction = createAction(
    ItemActions.CheckItem,
    props<{ payload: IItem }>()
);

export const UncheckItemAction = createAction(
    ItemActions.UncheckItem,
    props<{ payload: IItem }>()
);

export const UncheckAllItemsAction = createAction(
    ItemActions.UncheckAllItems
);

export const ChangePageAction = createAction(
    ItemActions.ChangePage,
    props<{ payload: number }>()
);

export const ChangeFilterSortDataAction = createAction(
    ItemActions.ChangeFilterSort,
    props<{ payload }>()
);

export const ChangeFilterAction = createAction(
    ItemActions.ChangeFilter,
    props<{ payload }>()
);

export const ChangeSortAction = createAction(
    ItemActions.ChangeSort,
    props<{ payload }>()
);

export const GetTotalItemsAction = createAction(
    ItemActions.GetTotalItems,
    props<{ payload: {projectId} }>()
);

export const TotalItemsLoadedAction = createAction(
    ItemActions.TotalItemsLoaded,
    props<{ payload }>()
);

export const BeginCutAndPasteItemsAction = createAction(
    ItemActions.BeginCutAndPasteItems,
    props<{ payload }>()
);

export const BeginCopyAndPasteItemsAction = createAction(
    ItemActions.BeginCopyAndPasteItems,
    props<{ payload: {itemIds: any[], projectId, strictClone } }>()
);

export const CutAndPasteItemsActionFinished = createAction(
    ItemActions.CutAndPasteItemsFinished,
    props<{ payload }>()
);

export const CopyAndPasteItemsActionFinished = createAction(
    ItemActions.CopyAndPasteItemsFinished,
    props<{ payload: { items } }>()
);

export const BeginDuplicateItemsAction = createAction(
    ItemActions.BeginDuplicateItems,
    props<{ payload }>()
);

export const DuplicateItemsFinishedAction = createAction(
    ItemActions.DuplicateItemsFinished,
    props<{ payload: { items } }>()
);

export const BeginRemoveItemsAction = createAction(
    ItemActions.BeginRemoveItems,
    props<{ payload }>()
);

export const RemoveItemsFinishedAction = createAction(
    ItemActions.RemoveItemsFinished,
    props<{ payload: { itemIds } }>()
);

export const BeginChangeOrderAction = createAction(
    ItemActions.BeginChangeOrder,
    props<{ payload }>()
);

export const ChangeOrderFinishedAction = createAction(
    ItemActions.ChangeOrderFinished,
    props<{ payload: { items } }>()
);

export const BeginCalculateRulesForItemAction = createAction(
    ItemActions.BeginCalulateRulesForItems,
    props<{ payload: { itemId, changedFields: string[] }[] }>()
);

export const CalculateRulesForItemFinishedAction = createAction(
    ItemActions.CalulateRulesForItemsFinished,
    props<{ payload: { changes: {_id, [techName: string]: string}[] }}>()
);

export const BeginRecalculateRulesForFieldsAction = createAction(
    ItemActions.BeginRecalculateRulesForField,
    props<{ payload: { projectId, techNames: string[] } }>()
);

export const RecalculateRulesForFieldsFinishedAction = createAction(
    ItemActions.RecalculateRulesForFieldFinished,
    props<{ payload: { message }}>()
);

export const UpdateProjectId = createAction(
    ItemActions.UpdateProjectId,
    props<{ payload: { projectId } }>()
);

export const BeginAddManyItemsAction = createAction(
  ItemActions.BeginAddManyItems,
  props<{ payload: {items, projectId } }>()
);

export const AddManyItemsFinishedAction = createAction(
  ItemActions.AddManyItemsFinished,
  props<{ payload: { items } }>()
);

export const ErrorItemsAction = createAction(
    ItemActions.ErrorItems, props<Error>()
);

export const ProjectEnteredAction = createAction(
    ItemActions.ProjectEntered,
    props<{ payload: { projectId } }>()
);
